import { __decorate } from "tslib";
import { Module, VuexModule, Mutation } from 'vuex-module-decorators';
let SettingsStore = class SettingsStore extends VuexModule {
    roles = null;
    setRoles(roles) {
        this.roles = roles;
    }
};
__decorate([
    Mutation
], SettingsStore.prototype, "setRoles", null);
SettingsStore = __decorate([
    Module({
        namespaced: true,
    })
], SettingsStore);
export default SettingsStore;
